import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Helper } from 'Components';
import NavDesktopItem from '../NavDesktopItem/NavDesktopItem';
import './NavDesktopItemsPinned.css';

const NavDesktopItemsPinned = ({
  options,
  filterItemValue,
  togglePin,
}) => {
  const { t } = useTranslation();
  return (
    <header className="nav__desktop__items__pinned">
      <Helper text={t('tutorials:dashboardOverview.17')}>
        <h3>{t('nav:Pinned')}</h3>
      </Helper>
      <ul>
        { options.map(x => (
          <NavDesktopItem
            key={x.value}
            filterItemValue={x.value}
            isActive={filterItemValue === x.value}
            togglePin={togglePin}
            isPinned
          />
        ))}
      </ul>
      <hr className="nav__desktop__items__pinned__hr" />
    </header>
  );
};

NavDesktopItemsPinned.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    isPinned: PropTypes.bool,
  })),
  filterItemValue: PropTypes.string,
  togglePin: PropTypes.func,
};

NavDesktopItemsPinned.defaultProps = {
  options: [],
};

export default NavDesktopItemsPinned;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopItemsPinned/NavDesktopItemsPinned.jsx